// Shopify Storefront API config. The token below is a *public* Storefront
// access token -- Shopify explicitly designs these to be safe in client-side
// code (unlike an Admin API key/secret), so hardcoding it here mirrors how
// firebaseConfig.js hardcodes its own public web config.
const SHOPIFY_STORE_DOMAIN = "pumpous-apparel.myshopify.com";
const SHOPIFY_STOREFRONT_TOKEN = "f77691f115468a6d5e1c26a54d06391d";
const SHOPIFY_API_VERSION = "2025-01";

const SHOPIFY_GRAPHQL_URL = `https://${SHOPIFY_STORE_DOMAIN}/api/${SHOPIFY_API_VERSION}/graphql.json`;

// Thin GraphQL client for the Storefront API. Throws on transport/GraphQL
// errors so callers (shopService.js) can catch in one place, same
// try/catch-and-return-{success,error} convention as the Firestore services.
export const shopifyFetch = async (query, variables = {}) => {
  const response = await fetch(SHOPIFY_GRAPHQL_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": SHOPIFY_STOREFRONT_TOKEN
    },
    body: JSON.stringify({ query, variables })
  });

  const json = await response.json();
  if (json.errors) {
    throw new Error(json.errors.map((e) => e.message).join("; "));
  }
  return json.data;
};
